import { cn } from "@productlane/lib/src/browser"

interface SystemEventEdges {
	hasAbove: boolean
	hasBelow: boolean
	isFirst: boolean
	isLast: boolean
	followsNote?: boolean
}

// The message group's own my-2 and py-2 already leave 16px; this adds a hair
// more where a system-event block meets a bubble so it never hugs it.
export const systemEventEdgeSpacing = (edges: SystemEventEdges) =>
	cn(
		// The note card has no margin, so a block under it adds the group's 8px.
		edges.isFirst ? edges.followsNote && "mt-2" : !edges.hasAbove && "mt-1",
		!edges.hasBelow && !edges.isLast && "mb-1",
	)
